import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { promotionsList, responsive } from './helpers';
import './styles.scss';
import NextButton from '../NextButton';

// Configuración alternativa para 2 promociones
const responsiveTwoPromos = {
  desktop: {
    breakpoint: { max: 3000, min: 992 },
    items: 2,
    partialVisibilityGutter: 40
  },
  tablet: responsive.tablet,
  mobile: responsive.mobile
};


const Promotions = () => {
  const PromotionItem = ({ image, title, description, link }) => (
    <a href={link} target="_blank" rel="noopener noreferrer" className="promo-link-card text-center" style={{ textDecoration: 'none', display: 'block' }}>
      <div className="promo-box mx-auto">
        <img
          src={image}
          alt={title}
          className="promo-img"
          onError={(e) => {
            if (!e.target.dataset.fallback) {
              e.target.dataset.fallback = '1';
              e.target.src = '/logo512.png';
            }
          }}
          loading="lazy"
        />
      </div>
      <h5 className="red-text">{title}</h5>
      <p className="gray-text mb-0">{description}</p>
    </a>
  );

  // Si hay dos promociones, mostrar fijas en desktop y carrusel en mobile
  const isTwoPromos = promotionsList.length === 2;

  return (
    <>
      <div className="container generic-padding-carousel mb-5 landing-scroll" id="promotions">
        <div className="row text-center pading-carousel-title">
          <div className="col">
            <h2 className="gray-text faq-lub-title landing-section-title">Conoce nuestras promociones</h2>
          </div>
        </div>
        {isTwoPromos ? (
          <>
            <div className="d-none d-md-flex justify-content-center align-items-start promotions-fixed-row promotions-fixed-row--two">
              {promotionsList.map((p) => (
                <div key={p.key} className="promotions-fixed-col">
                  <PromotionItem image={p.image} title={p.title} description={p.description} link={p.link} />
                </div>
              ))}
            </div>
            {/* Mobile: carrusel */}
            <div className="d-block d-md-none">
              <Carousel
                swipeable={false}
                draggable={false}
                showDots={false}
                responsive={responsiveTwoPromos}
                ssr
                infinite
                autoPlay
                autoPlaySpeed={6000}
                keyBoardControl
                transitionDuration={500}
                containerClass="react-multi-carousel-size"
                itemClass="carousel-item-padding-40-px"
              >
                {promotionsList.map((p) => (
                  <div key={p.key}>
                    <PromotionItem image={p.image} title={p.title} description={p.description} link={p.link} />
                  </div>
                ))}
              </Carousel>
            </div>
          </>
        ) : (
          <Carousel
            swipeable={false}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr
            infinite
            autoPlay
            autoPlaySpeed={6000}
            keyBoardControl
            transitionDuration={500}
            containerClass="react-multi-carousel-size"
            itemClass="carousel-item-padding-40-px"
          >
            {promotionsList.map((p) => (
              <div key={p.key}>
                <PromotionItem image={p.image} title={p.title} description={p.description} link={p.link} />
              </div>
            ))}
          </Carousel>
        )}
      </div>
      <NextButton arrowColor='redArrow' sectionId='#shell-experience' />
    </>
  );
};

export default Promotions;
